import firebase from 'firebase';
// import * as firebaseui from 'firebaseui';

// Initialize Firebase
var config = {
  apiKey: "AIzaSyACrQqW99Lk5cY6AmdaNTMBjxAAiQwZ9BI",
  authDomain: "codoc-landing.firebaseapp.com",
  databaseURL: "https://codoc-landing.firebaseio.com",
  projectId: "codoc-landing",
  storageBucket: "codoc-landing.appspot.com",
  messagingSenderId: "990043987147"
};
firebase.initializeApp(config);

// var ui = new firebaseui.auth.AuthUI(firebase.auth());

const firestoreDB = firebase.firestore();
// Disable deprecated features
firestoreDB.settings({
  timestampsInSnapshots: true
});
// ui.start('#firebaseui-auth-container', firebaseuiConfig);
const firebaseStorage = firebase.storage();
const firebaseAuth = firebase.auth();
firebase.auth().useDeviceLanguage();

export { firebase, firestoreDB, firebaseStorage};
